<template>
    <v-card>
        <v-card-title primary-title class="title d-flex justify-center">The Prediction Equation of Raw Palm Meat for Palm Farmers.</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-container grid-list-xs>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="headline">
                            m = 0.5659x - 0.7454
                        </div>
                        <div class="body-1">
                            m is total weight
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-text>
            <v-container grid-list-xs>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-text-field
                            outline
                            label="Please Provide x value"
                            v-model="x"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex text-xs-center">
            <v-btn @click="calculate" flat>
                Calculate
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "Calculator",
    data: () => ({
        x: 0
    }),
    methods: {
        calculate() {
            // let result = 0.5659*this.x - 0.7454;
            this.$emit('calculate', this.x)
        }
    }
}
</script>

<style scoped>
/* .card-container {
    min-height: 300px;
} */
</style>
